if (!customElements.get('jk-purchase-repeat')) {
  customElements.define('jk-purchase-repeat', class extends HTMLElement {
    async connectedCallback() {
      const controller = new AbortController();
      this.controller = controller;
      await Promise.all(['product-info', 'product-form'].map((name) => customElements.whenDefined(name)));
      if (controller.signal.aborted || !this.isConnected) return;

      const info = document.querySelector(`product-info[id^="MainProduct-"][data-product-id="${this.dataset.productId}"]`);
      if (!info) return;
      this.sourceInput = info.querySelector(`#Quantity-${info.dataset.section}`);
      this.form = info.querySelector(`#product-form-${info.dataset.section}`);
      this.sourceButton = info.querySelector(`#ProductSubmitButton-${info.dataset.section}`);
      if (!this.sourceInput || !this.form || !this.sourceButton) return;

      this.input = this.querySelector('input');
      this.button = this.querySelector('[data-jk-repeat-submit]');
      this.sourceQuantity = this.sourceInput.closest('.product-form__quantity');
      this.sourceProductForm = this.form.closest('product-form');
      this.sourcePrice = info.querySelector(`#price-${info.dataset.section}`);
      const options = { signal: controller.signal };
      const sync = () => this.sync();

      this.sourceInput.addEventListener('input', sync, options);
      this.sourceInput.addEventListener('change', sync, options);
      for (const eventName of ['input', 'change']) {
        this.input.addEventListener(eventName, () => {
          this.sourceInput.value = this.input.value;
          this.sourceInput.dispatchEvent(new Event(eventName, { bubbles: true }));
        }, options);
      }
      this.button.addEventListener('click', () => this.submit(), options);
      this.input.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.submit();
      }, options);
      this.form.addEventListener('submit', (event) => {
        if (this.sourceInput.checkValidity()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const input = this.contains(document.activeElement) ? this.input : this.sourceInput;
        input.reportValidity();
      }, { ...options, capture: true });

      this.observer = new MutationObserver(sync);
      this.observer.observe(this.sourceQuantity, { attributes: true, childList: true, characterData: true, subtree: true });
      this.observer.observe(this.sourceProductForm, { attributes: true, childList: true, characterData: true, subtree: true });
      if (this.sourcePrice) this.observer.observe(this.sourcePrice, { attributes: true, childList: true, characterData: true, subtree: true });
      this.sync();
      this.hidden = false;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    sync() {
      for (const name of ['min', 'max', 'step', 'data-min', 'data-max', 'data-cart-quantity']) {
        const value = this.sourceInput.getAttribute(name);
        if (value === null) this.input.removeAttribute(name);
        else this.input.setAttribute(name, value);
      }
      this.input.value = this.sourceInput.value;
      this.querySelector('quantity-input').validateQtyRules?.();
      const sourceLabel = this.sourceQuantity.querySelector('.quantity__label');
      const accessibleLabel = document.getElementById(sourceLabel.getAttribute('aria-labelledby'));
      this.querySelector('label').textContent = (accessibleLabel || sourceLabel).textContent.replace(/\s+/g, ' ').trim();
      this.querySelector('.quantity__rules').textContent = this.sourceQuantity.querySelector('.quantity__rules')?.textContent.replace(/\s+/g, ' ').trim() || '';
      const price = this.querySelector('.jk-purchase-repeat__price');
      price.hidden = !this.sourcePrice || this.sourcePrice.classList.contains('hidden');
      const priceMarkup = this.sourcePrice?.querySelector('.price')?.outerHTML || '';
      if (price.innerHTML !== priceMarkup) price.innerHTML = priceMarkup;

      const busy = this.sourceButton.getAttribute('aria-disabled') === 'true';
      this.button.disabled = this.sourceButton.disabled || busy;
      this.button.setAttribute('aria-disabled', String(this.button.disabled));
      this.button.classList.toggle('loading', this.sourceButton.classList.contains('loading'));
      this.button.querySelector('span').textContent = this.sourceButton.querySelector('span').textContent;
      this.button.querySelector('.loading__spinner').classList.toggle('hidden', !this.sourceButton.classList.contains('loading'));
      const popup = this.sourceButton.getAttribute('aria-haspopup');
      if (popup) this.button.setAttribute('aria-haspopup', popup);
      else this.button.removeAttribute('aria-haspopup');

      const sourceError = this.sourceProductForm.querySelector('.product-form__error-message-wrapper');
      const error = this.querySelector('.product-form__error-message');
      error.hidden = !sourceError || sourceError.hidden;
      error.textContent = sourceError?.querySelector('.product-form__error-message')?.textContent || '';
    }

    submit() {
      if (this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true') return;
      if (!this.input.reportValidity()) return;
      this.form.requestSubmit(this.sourceButton);
    }
  });
}
